const NON_PUBLIC_PREFIXES = [
  '/api',
  '/dashboard',
  '/login',
  '/signup',
  '/partner-signup',
  '/forgotpasscode',
  '/video-chat',
  '/payment-success',
];

const PRIVATE_HOSTS = [
  'portal.yourmentra.com',
];

function normalizePath(pathname) {
  const path = (pathname || '/').toLowerCase();
  return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
}

export function isNonPublicPath(pathname) {
  const path = normalizePath(pathname);
  return NON_PUBLIC_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export function isStagingOrDevHost(hostname) {
  if (!hostname) return false;
  const host = hostname.toLowerCase();
  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.includes('staging') ||
    host.startsWith('dev.') ||
    host.endsWith('.local')
  );
}

export function isPrivateAppHost(hostname) {
  if (!hostname) return false;
  const host = hostname.toLowerCase();
  return PRIVATE_HOSTS.includes(host) || host.startsWith('portal.');
}

export function shouldNoIndex(pathname, hostname) {
  if (import.meta.env.DEV) return true;
  if (isPrivateAppHost(hostname)) return true;
  if (isStagingOrDevHost(hostname)) return true;
  return isNonPublicPath(pathname);
}
